import { render, staticRenderFns } from "./kTomIndex_kdr.vue?vue&type=template&id=eaea84aa&scoped=true&"
import script from "./kTomIndex_kdr.vue?vue&type=script&lang=js&"
export * from "./kTomIndex_kdr.vue?vue&type=script&lang=js&"
import style0 from "./kTomIndex_kdr.vue?vue&type=style&index=0&id=eaea84aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaea84aa",
  null
  
)

export default component.exports